document.addEventListener('DOMContentLoaded', initShelterConfigurator);
document.addEventListener('shopify:section:load', initShelterConfigurator);

function initShelterConfigurator(event) {
  var scope = event && event.target ? event.target : document;

  scope.querySelectorAll('.shelter-configurator__body').forEach(function (root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var chips = root.querySelectorAll('.filter-chip');
    var cards = root.querySelectorAll('.config-product-card');
    var resetButton = root.querySelector('[data-reset]');
    var countEl = root.querySelector('[id^="results-count-"]');
    var activeFiltersEl = root.querySelector('[id^="active-filters-"]');

    /* --------------------------------------------------------
       Load translated labels from the JSON block injected by
       Liquid. Used to translate raw metafield values displayed
       on product cards.
    -------------------------------------------------------- */
    var sectionId = root.dataset.sectionId;
    var translations = {};
    var translationsEl = document.getElementById('shelter-translations-' + sectionId);
    if (translationsEl) {
      try {
        translations = JSON.parse(translationsEl.textContent);
      } catch (e) {
        translations = {};
      }
    }

    var state = {
      tipo_pianta: new Set(),
      protezione_da: new Set(),
      contesto: new Set(),
      materiale: new Set(),
      protezione: new Set()
    };

    /* --------------------------------------------------------
       ALIAS_MAP
       Maps each canonical key to known translations/synonyms
       in IT, FR, DE.  Used to match raw metafield values
       (which may be in any language) to canonical keys.

       FIX: removed "schraube" (= screw) from "vite" aliases.
       FIX: added each canonical key with underscores as first
            alias so chip data-values always self-match.
    -------------------------------------------------------- */
    var ALIAS_MAP = {
      tipo_pianta: {
        conifere: [
          'conifere',
          'conifera',
          'conifer',
          'conifères',
          'nadelbäume',
          'nadelbaum',
          'nadelbaeume',
          'nadelgehölze',
          'nadelgeholze'
        ],
        latifoglie: [
          'latifoglie',
          'feuillus',
          'feuillu',
          'laubbäume',
          'laubbaum',
          'laubgehölze',
          'laubgehölz',
          'laubgeholze',
          'laubgeholz'
        ],
        alberi_frutto: [
          'alberi_frutto',
          'alberi da frutto',
          'albero da frutto',
          'arbres fruitiers',
          'arbre fruitier',
          'obstbäume',
          'obstbaum',
          'obstbaeume'
        ],
        vite: [
          'vite',
          'vigna',
          'vigne',
          'weinrebe',
          'weinreben'
        ],
        ornamentali: [
          'ornamentali',
          'ornamentale',
          'ornementales',
          'ornementale',
          'zierpflanzen',
          'zierpflanze'
        ]
      },

      protezione_da: {
        roditori: [
          'roditori',
          'roditore',
          'rongeurs',
          'rongeur',
          'nagetiere',
          'nagetier'
        ],
        cinghiali: [
          'cinghiali',
          'cinghiale',
          'sangliers',
          'sanglier',
          'wildschweine',
          'wildschwein'
        ],
        caprioli: [
          'caprioli',
          'capriolo',
          'chevreuils',
          'chevreuil',
          'rehe',
          'reh',
          'rehböcke',
          'rehbocke',
          'rehbock'
        ],
        cervi_grandi_ungulati: [
          'cervi_grandi_ungulati',
          'cervi e grandi ungulati',
          'cervo e grandi ungulati',
          'grandi ungulati',
          'cerfs et grands ongulés',
          'cerf et grands ongulés',
          'cerfs et grands ongules',
          'cerf et grands ongules',
          'grands ongulés',
          'grands ongules',
          'hirsche und großes schalenwild',
          'hirsch und großes schalenwild',
          'hirsche und grosses schalenwild',
          'hirsch und grosses schalenwild',
          'großes schalenwild',
          'grosses schalenwild',
          'hirsche und große huftiere',
          'hirsch und große huftiere',
          'hirsche und grosse huftiere',
          'hirsch und grosse huftiere',
          'große huftiere',
          'grosse huftiere'
        ]
      },

      contesto: {
        forestazione: [
          'forestazione',
          'reboisement',
          'reforestation',
          'aufforstung',
          'forstwirtschaft',
          'foresterie',
          'sylviculture'
        ],
        vivaio: [
          'vivaio',
          'pépinière',
          'pepiniere',
          'baumschule',
          'gärtnerei',
          'gartnerei'
        ],
        frutteto: [
          'frutteto',
          'verger',
          'obstgarten'
        ],
        vigneto: [
          'vigneto',
          'vignoble',
          'weinberg'
        ],
        giardino: [
          'giardino',
          'jardin',
          'garten'
        ]
      },

      materiale: {
        biodegradabile: [
          'biodegradabile',
          'biodégradable',
          'biodegradable',
          'biologisch abbaubar',
          'biologisch abbaubare',
          'biologisch abbaubares material'
        ],
        riciclabile: [
          'riciclabile',
          'recyclable',
          'recycelbar',
          'recyclebar'
        ]
      },

      protezione: {
        base: ['base', 'basis'],
        medio: ['medio', 'moyen', 'mittel', 'durchschnitt'],
        alto: ['alto', 'élevé', 'eleve', 'élevée', 'elevee', 'hoch', 'grand'],
        professionale: ['professionale', 'professionnel', 'professionnelle', 'professionell', 'professional']
      }
    };

    /* --------------------------------------------------------
       CHIP CLICK HANDLER
       FIX: Use raw chip.dataset.value (the canonical key like
       "alberi_frutto") directly. Do NOT run normalizeForMatch
       on it. This ensures state keys match canonicalizeValue
       return values exactly.
    -------------------------------------------------------- */
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var group = chip.dataset.group;
        var value = chip.dataset.value;

        if (!group || !value || !state[group]) return;

        if (state[group].has(value)) {
          state[group].delete(value);
        } else {
          state[group].add(value);
        }

        syncChipStates();
        applyFilters();
      });
    });

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        Object.keys(state).forEach(function (group) {
          state[group].clear();
        });
        syncChipStates();
        applyFilters();
      });
    }

    /* --------------------------------------------------------
       APPLY FILTERS
    -------------------------------------------------------- */
    function applyFilters() {
      var visibleCount = 0;

      cards.forEach(function (card) {
        var tipoPiantaValues = parseCanonicalValues(card.dataset.tipoPianta, 'tipo_pianta');
        var protezioneDaValues = parseCanonicalValues(card.dataset.protezioneDa, 'protezione_da');
        var contestoValues = parseCanonicalValues(card.dataset.contesto, 'contesto');
        var materialeValues = parseCanonicalValues(card.dataset.materiale, 'materiale');
        var protezioneValues = parseCanonicalValues(card.dataset.protezione, 'protezione');

        var matches =
          matchesGroup(tipoPiantaValues, state.tipo_pianta) &&
          matchesGroup(protezioneDaValues, state.protezione_da) &&
          matchesGroup(contestoValues, state.contesto) &&
          matchesGroup(materialeValues, state.materiale) &&
          matchesGroup(protezioneValues, state.protezione);

        card.hidden = !matches;

        if (matches) visibleCount += 1;
      });

      if (countEl) {
        countEl.textContent = String(visibleCount);
      }

      renderBadges();
      translateCardMeta();
    }

    /* --------------------------------------------------------
       parseCanonicalValues
    -------------------------------------------------------- */
    function parseCanonicalValues(rawValue, group) {
      var rawItems = parseDataValues(rawValue);
      var canonical = new Set();

      rawItems.forEach(function (item) {
        var pieces = splitMultiValue(item);

        pieces.forEach(function (piece) {
          var mapped = canonicalizeValue(group, piece);
          if (mapped) canonical.add(mapped);
        });
      });

      return Array.from(canonical);
    }

    function parseDataValues(rawValue) {
      if (!rawValue) return [];

      try {
        var parsed = JSON.parse(rawValue);

        if (Array.isArray(parsed)) {
          return parsed.map(function (item) { return String(item || ''); }).filter(Boolean);
        }

        if (typeof parsed === 'string') {
          return [parsed];
        }

        if (parsed != null) {
          return [String(parsed)];
        }
      } catch (error) {
        /* not valid JSON */
      }

      return [String(rawValue)];
    }

    function splitMultiValue(value) {
      return String(value || '')
        .split(',')
        .map(function (item) { return item.trim(); })
        .filter(Boolean);
    }

    /* --------------------------------------------------------
       canonicalizeValue — given a raw metafield value and a
       group name, returns the canonical key or null.
    -------------------------------------------------------- */
    function canonicalizeValue(group, value) {
      var normalized = normalizeForMatch(value);
      var groupMap = ALIAS_MAP[group];

      if (!groupMap || !normalized) return null;

      var keys = Object.keys(groupMap);
      for (var k = 0; k < keys.length; k++) {
        var canonical = keys[k];
        var aliases = groupMap[canonical];

        for (var a = 0; a < aliases.length; a++) {
          var normalizedAlias = normalizeForMatch(aliases[a]);

          if (
            normalized === normalizedAlias ||
            normalized.indexOf(normalizedAlias) !== -1 ||
            normalizedAlias.indexOf(normalized) !== -1
          ) {
            return canonical;
          }
        }
      }

      return null;
    }

    /* --------------------------------------------------------
       normalizeForMatch — normalize a string for comparison.

       FIX: Does NOT convert underscores to spaces. Underscores
       are part of canonical keys and must be preserved.
    -------------------------------------------------------- */
    function normalizeForMatch(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/&quot;|&#34;/g, '"')
        .replace(/&amp;/g, '&')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function matchesGroup(cardValues, activeSet) {
      if (activeSet.size === 0) return true;
      if (!cardValues || cardValues.length === 0) return false;

      var activeArr = Array.from(activeSet);
      for (var i = 0; i < activeArr.length; i++) {
        if (cardValues.indexOf(activeArr[i]) !== -1) return true;
      }
      return false;
    }

    /* --------------------------------------------------------
       syncChipStates
       FIX: compare against raw chip.dataset.value
    -------------------------------------------------------- */
    function syncChipStates() {
      chips.forEach(function (chip) {
        var group = chip.dataset.group;
        var value = chip.dataset.value;
        var isActive = !!(state[group] && state[group].has(value));

        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    /* --------------------------------------------------------
       renderBadges
    -------------------------------------------------------- */
    function renderBadges() {
      if (!activeFiltersEl) return;

      activeFiltersEl.innerHTML = '';

      Object.keys(state).forEach(function (group) {
        state[group].forEach(function (value) {
          var badge = document.createElement('span');
          badge.className = 'active-filter-badge';
          badge.textContent = getChipLabel(group, value);
          activeFiltersEl.appendChild(badge);
        });
      });
    }

    function getChipLabel(group, canonicalKey) {
      var matchingChip = null;
      for (var i = 0; i < chips.length; i++) {
        if (chips[i].dataset.group === group && chips[i].dataset.value === canonicalKey) {
          matchingChip = chips[i];
          break;
        }
      }
      return matchingChip ? matchingChip.textContent.trim() : canonicalKey;
    }

    /* --------------------------------------------------------
       translateCardMeta — replaces raw (Italian) metafield
       values on product cards with translated labels from the
       Liquid-injected translations JSON.

       NEW FUNCTION: fixes the problem where product cards
       always show Italian text for materiale, protezione and
       contesto regardless of the active language.
    -------------------------------------------------------- */
    function translateCardMeta() {
      if (!translations || Object.keys(translations).length === 0) return;

      cards.forEach(function (card) {
        var metaItems = card.querySelectorAll('[data-meta-group]');

        metaItems.forEach(function (li) {
          var group = li.getAttribute('data-meta-group');
          if (!group || !translations[group]) return;

          var rawAttr = '';
          if (group === 'materiale') rawAttr = card.dataset.materiale;
          else if (group === 'protezione') rawAttr = card.dataset.protezione;
          else if (group === 'contesto') rawAttr = card.dataset.contesto;

          if (!rawAttr) return;

          var rawItems = parseDataValues(rawAttr);
          var translatedParts = [];

          rawItems.forEach(function (item) {
            var pieces = splitMultiValue(item);
            pieces.forEach(function (piece) {
              var canonical = canonicalizeValue(group, piece);
              if (canonical && translations[group] && translations[group][canonical]) {
                translatedParts.push(translations[group][canonical]);
              } else {
                translatedParts.push(piece.trim());
              }
            });
          });

          /* Remove duplicates */
          var unique = [];
          for (var i = 0; i < translatedParts.length; i++) {
            if (unique.indexOf(translatedParts[i]) === -1) {
              unique.push(translatedParts[i]);
            }
          }

          li.textContent = unique.join(', ');
        });
      });
    }

    /* --------------------------------------------------------
       INIT
    -------------------------------------------------------- */
    syncChipStates();
    applyFilters();
  });
}